import * as Yup from "yup";
import { changePasswordAdminService } from "../../services/usersServices";
import Alert from "../../utils/Alert";

export const initialValues = {
    old_password: "",
    new_password: "",
    confirm_password: ""
};

export const onSubmit = async (values, actions) => {
    try {
        const response = await changePasswordAdminService(values);
        if(response.status === 200) {
            actions.resetForm();
            Alert("انجام عملیات", "رمز عبور شما با موفقیت تغییر کرد.", "success");
        }
    } catch (error) {
        if(error.response && error.response.status === 400) {
            Alert(`خطا ${error.response.status}!`, "رمز عبور فعلی صحیح نمی باشد.", "error");
        }
    }
};

export const validationSchema = Yup.object({
    old_password: Yup.string().required("لطفاً رمز عبور فعلی خود را وارد کنید"),
    new_password: Yup.string().required("لطفاً رمز عبور جدید را وارد کنید")
        .matches(/^[a-zA-Z0-9_]+$/, "داخل رمز از نمادها و فاصله استفاده نکنید"),
    confirm_password: Yup.string().required("لطفاً تکرار رمز عبور را وارد کنید")
        .oneOf([Yup.ref("new_password")], "با رمز عبور مطابقت ندارد"),
});